import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.001 1 11 11l10 9.998",
      stroke: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "m20.998 1-9.999 10-10 9.998",
      stroke: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }